package link.erpango.quip.domain.services

import link.erpango.quip.domain.entities.DMaintenance

/**
 * Signs a new maintenance and its spare parts before it is created. The signature chains to
 * the latest (by date) of the vehicle's [existing] maintenances, so every creation path
 * (the form and the note import) builds the same chain.
 */
fun signNewMaintenance(maintenance: DMaintenance, existing: List<DMaintenance>): DMaintenance {
    val lastMaintenance = existing.maxByOrNull { it.date }
    val signature = SignatureService.signMaintenance(maintenance, lastMaintenance?.signature)
    val signedSpareParts = maintenance.spareParts.map {
        it.copy(signature = SignatureService.signSparePart(it))
    }
    return maintenance.copy(signature = signature, spareParts = signedSpareParts)
}
